<template>
    <van-dialog 
      :value="value" 
      title="提示" 
      class="duplicate-dialog-contain"
      @confirm="$emit('input', false)"
      :confirmButtonText="'我知道了'">
      <div class="cost-dialog">
        <div class="top-tips">
          已经存在重复{{scopeStr}}，无法{{operateType}}
        </div>
        <div class="less-box">
          <div class="stu-line" v-for="(item, index) in datas" :key="index">
            {{item.name}} ({{item.type===1?'意向':(item.intentionStatus===1?'意向学员':'学员')}})<br>
            <span>
              {{getStudentPhoneNum(item)}} 
              <span v-if="item.followTeacherName">(跟进人: {{item.followTeacherName}})</span>
            </span>
          </div>
        </div>
        <div class="top-tips" style="font-size: var(--fs-sm);color:var(--g6);" v-if="tipsStr">{{tipsStr}}</div>
      </div>
    </van-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      rquired: true,
    },
    datas: {
      type: Array,
      rquired: true,
    },
    operateType: {
      type: String,
      default: '添加'
    },
    tipsStr: {
      type: String,
      default: '',
    },
    scopeStr: {
      type: String,
      default: '意向或学员',
    }
  },
  data() {
    return {};
 },
  methods: {
    getStudentPhoneNum (student) {
      let { studentParentList = [] } = student;
      if (studentParentList[0]) {
        return studentParentList[0].parentPhone || '-';
      } 
      return '-';
    }
  },
};
</script>

<style lang="scss">
.duplicate-dialog-contain{
  .top-tips {
    margin-bottom: calc(var(--gap) * 10);
    padding: calc(var(--gap) * 8) calc(var(--gap) * 24) 0 calc(var(--gap) * 24);
    color: var(--g7);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
  }
  .less-box {
    overflow-y: scroll;
    max-height: calc(var(--w) * 268);
    color: var(--g8);
    .stu-line {
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      margin: calc(var(--gap) * 8) calc(var(--gap) * 24);
      padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
      border-radius: var(--radius-sm);      
      background: var(--g1);
    }
  }
}
</style>